import React, { Component } from "react";
import { fire, auth } from "../../../firebase/index";
//? English Version
import subscribeInstruction1 from "../../../assets/img/tutorialimages/subscribeGuide1.png";
import subscribeInstruction2 from "../../../assets/img/tutorialimages/subscribeGuide2.png";
import subscribeInstruction3 from "../../../assets/img/tutorialimages/subscribeGuide3.png";
//? Japanese Version
import subscribeInstruction1Jap from "../../../assets/img/tutorialimages/subscribeGuide1_Jap.png";
import subscribeInstruction2Jap from "../../../assets/img/tutorialimages/subscribeGuide2_Jap.png";
import subscribeInstruction3Jap from "../../../assets/img/tutorialimages/subscribeGuide3_Jap.png";
import subscribeInstruction4Jap from "../../../assets/img/tutorialimages/subscribeGuide4_Jap.png";
import subscribeInstruction5Jap from "../../../assets/img/tutorialimages/subscribeGuide5_Jap.png";

class SubscribePlanGuidebot extends Component {
  state = {
    language: "en",
  };

  componentDidMount() {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            language: snapshot.val(),
          });
        });
    }
  }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    const { language } = this.state;
    return (
      <div
        style={{
          width: "90%",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <img
          className="imgStyle"
          src={
            language === "en"
              ? subscribeInstruction1
              : language === "ja"
              ? subscribeInstruction1Jap
              : language === "es"
              ? subscribeInstruction1
              : subscribeInstruction1
          }
          alt="subscribeInstruction1"
          style={{
            width: "100%",
            marginLeft: "auto",
            marginRight: "auto",
            height: "100%",
          }}
        />
        <img
          className="imgStyle"
          src={
            language === "en"
              ? subscribeInstruction2
              : language === "ja"
              ? subscribeInstruction2Jap
              : language === "es"
              ? subscribeInstruction2
              : subscribeInstruction2
          }
          alt="subscribeInstruction2"
          style={{
            width: "100%",
            marginLeft: "auto",
            marginRight: "auto",
            height: "100%",
          }}
        />
        <img
          className="imgStyle"
          src={
            language === "en"
              ? subscribeInstruction3
              : language === "ja"
              ? subscribeInstruction3Jap
              : language === "es"
              ? subscribeInstruction3
              : subscribeInstruction3
          }
          alt="subscribeInstruction3"
          style={{
            width: "100%",
            marginLeft: "auto",
            marginRight: "auto",
            height: "100%",
          }}
        />
        {language === "ja" && (
          <>
            <img
              className="imgStyle"
              src={subscribeInstruction4Jap}
              alt="subscribeInstruction4"
              style={{
                width: "100%",
                marginLeft: "auto",
                marginRight: "auto",
                height: "100%",
              }}
            />

            <img
              className="imgStyle"
              src={subscribeInstruction5Jap}
              alt="subscribeInstruction5"
              style={{
                width: "100%",
                marginLeft: "auto",
                marginRight: "auto",
                height: "100%",
              }}
            />
          </>
        )}  
      </div>
    );
  }
}

export default SubscribePlanGuidebot;
